import { writable } from 'svelte/store';
export function serializeSchema(schema) {
    return `<script type="application/ld+json">${JSON.stringify(schema, null, 2)}</script>`;
}
export const meta = writable({ title: 'BikerToyz' });
